module.exports = __webpack_public_path__ + "img/carousel-1.7a177f34.jpg";